import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { IagPortalSupportPage } from 'src/app/model/page/group/iag-portal/iag-portal-support-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { GroupValidator } from 'src/app/validator/group-validator';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-iag-portal-support-page',
  templateUrl: './iag-portal-support-page.component.html',
  styleUrls: ['./iag-portal-support-page.component.scss']
})
export class IagPortalSupportPageComponent implements OnInit {
  iagPortalSupportPage: IagPortalSupportPage = {} as IagPortalSupportPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'iag-portal-support') {
        this.iagPortalSupportPage.htmlTitle = title.htmlTitle;
      }
    });
    this.iagPortalSupportPage.sections = [];
    this.iagPortalSupportPage.tableSections = [];
    this.iagPortalSupportPage.sectionsJustBelowTable = [];
    this.iagPortalSupportPage.sectionsJustAboveTable = [];

    const query = { 'fields.title': 'IAG Portal Support' };
    this.contentfulService.getPageContentResponse(query).then((IagPortalSupportPageEntries) => {
      this.mapBanner(IagPortalSupportPageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.iagPortalSupportPage.banner);
      this.mapPageInfo(IagPortalSupportPageEntries.items);
      this.mapSections(IagPortalSupportPageEntries.includes.Entry);
      this.mapTableSection(IagPortalSupportPageEntries.includes.Entry);
    });
  }

  private mapBanner(iagPortalSupportPageEntries: Entry<any>[]) {
    iagPortalSupportPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {

    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];

    this.iagPortalSupportPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: videoDetails?.fields?.file?.url
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.iagPortalSupportPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.iagPortalSupportPage.banner.url = entry.fields?.url;
      this.iagPortalSupportPage.banner.editorEmail = editorDetails?.pop();
      this.iagPortalSupportPage.banner.editorShortName = editorDetails?.pop();
      this.iagPortalSupportPage.banner.editorFullName = editorDetails?.pop();
      this.iagPortalSupportPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
  private mapSections(iagPortalSupportPageEntries: Entry<any>[]) {
    iagPortalSupportPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
        this.iagPortalSupportPage.sectionsJustBelowTable = this.iagPortalSupportPage.sections.filter((section) => GroupValidator.isJustBelowTable(section.group));
        this.iagPortalSupportPage.sectionsJustBelowTable.sort((a, b) => a.order - b.order);
        this.iagPortalSupportPage.sectionsJustAboveTable = this.iagPortalSupportPage.sections.filter((section) => GroupValidator.isJustAboveTable(section.group));
        this.iagPortalSupportPage.sectionsJustAboveTable.sort((a, b) => a.order - b.order);
      });
    this.iagPortalSupportPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    
    let title:any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    // console.log(entry);
    this.iagPortalSupportPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      titleColorClass: entry.fields['sectionClass'] as string
    });
  }
  private mapTableSection(iagPortalSupportPageEntries: Entry<any>[]) {
    iagPortalSupportPageEntries
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryToTableSection(entry);
      });
  }

  private mapEntryToTableSection(entry: Entry<any>) {
    let title:any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    this.iagPortalSupportPage.tableSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      table: entry.fields['table'] as string
    });
  }
}
